import script from "./ServiceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceInfo.vue?vue&type=script&setup=true&lang=js"

import "./ServiceInfo.vue?vue&type=style&index=0&id=5248214c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5248214c"]])

export default __exports__